import{useMemo as t}from"react";import{getOwnerDocument as o}from"../utils/owner.js";function n(...e){return t(()=>o(...e),[...e])}export{n as useOwnerDocument};
